import { createApp } from 'vue'
import store from 'store'

import CheckoutBillingInfo from './CheckoutBillingInfo.vue'

const el = '.nti-component--checkout-billing'
const DOM = document.querySelector(el)

const render = function(){
    if(DOM){
        const action = DOM.dataset.action
        const app = createApp(CheckoutBillingInfo, {
            action: action
        })
        app.use(store)
        app.mount(el)
    }
}

export default {
    render
}